/*
 * Phone and email links, everywhere (owner, 2026-11-02). A phone link rings on a phone, as always; on a device that
 * can't (a mouse rather than a touch screen: a computer) it copies the number and shows it (layout/dialogs:
 * dialog-phone), to call from a phone. An email link opens in a new tab, so a web mail (Gmail…) doesn't replace the page.
 */
const canCall = () => matchMedia('(pointer: coarse)').matches;

Alpine.store('phone', {
    number: '',
    copied: false,

    async show(number) {
        this.number = number;
        this.copied = await navigator.clipboard?.writeText(number).then(() => true, () => false) ?? false;
        window.dispatchEvent(new CustomEvent('dialog-phone', { detail: 'open' }));
    },
});

document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href^="tel:"], a[href^="mailto:"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;

    if (link.protocol === 'mailto:') {
        link.target ||= '_blank';
        link.rel ||= 'noopener';
    } else if (!canCall()) {
        event.preventDefault();
        Alpine.store('phone').show(decodeURIComponent(link.href.slice(4)));
    }
});
